import { pickOrderApi } from "./pickOrder";

export const { useCreatePepsiOrderMutation } = pickOrderApi;
